module.exports = __webpack_public_path__ + "img/marker-point-rojo.02854988.png";